// Invites org admins to turn on AI for uploads (ENG-3664). Nothing is stored
// server side: once any admin opts in, the org has one of the two features and
// the prompt stops for everyone; "Not now" lives in this browser's localStorage,
// per admin, so another admin signing in on the same browser still sees it.

export const AI_ON_UPLOADS_FEATURES = ['auto_ai_on_uploads', 'manual_ai_on_uploads'];
export const AI_ON_UPLOADS_PROMPT_DISMISSED_KEY = 'm8_hideAiOnUploadsPrompt';

// Sign-out wipes every m8_ key; `actions/auth.js#resetAuth` keeps this one so a
// dismissal survives the next login in the same browser.
export const PRESERVED_AI_ON_UPLOADS_PROMPT_KEYS = new Set([AI_ON_UPLOADS_PROMPT_DISMISSED_KEY]);

// Bounds the list on a browser many admins share.
const MAX_DISMISSALS = 50;

// The key outlives sign-out, so it holds a short hash of each admin's email
// rather than the email itself (djb2, kept to 32 bits). A collision only hides
// one prompt.
const adminKey = (uid) => {
  const text = String(uid).trim().toLowerCase();
  let hash = 5381;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 33 + text.charCodeAt(i)) % 4294967296;
  }
  return hash.toString(36);
};

const readDismissals = () => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(AI_ON_UPLOADS_PROMPT_DISMISSED_KEY));
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

// Cheap checks first, so non-admins and dismissed admins never fetch features.
// Without a signed-in identity there is no one to remember "Not now" for.
export const mayShowAiOnUploadsPrompt = ({ isAdmin, uid }) => (
  Boolean(isAdmin) && Boolean(uid) && !readDismissals().includes(adminKey(uid))
);

export const orgHasAiOnUploads = (activeFeatures = []) => (
  AI_ON_UPLOADS_FEATURES.some((name) => activeFeatures.includes(name))
);

export const dismissAiOnUploadsPrompt = (uid) => {
  if (!uid) return;
  const key = adminKey(uid);
  const dismissals = readDismissals().filter((entry) => entry !== key);
  try {
    window.localStorage.setItem(
      AI_ON_UPLOADS_PROMPT_DISMISSED_KEY,
      JSON.stringify([...dismissals, key].slice(-MAX_DISMISSALS)),
    );
  } catch {
    // Nothing to remember it in; the prompt may show again.
  }
};
